import * as React from 'react';

interface ContentProps {
	html: string;
	css: string;
	scripts?: string;
}

enum ResourceType {
	STYLE = 'style',
	SCRIPT = 'script',
}

const Content = ({ html, css, scripts }: ContentProps) => {
	const STYLE_ID = 'editor-styles';
	const SCRIPTS_ID = 'editor-scripts';

	const element = React.useRef<HTMLDivElement>(null);

	const addResource = (type: ResourceType, id: string, resource: string): void => {
		const element = document.createElement(type);
		element.id = id;
		element.innerHTML = resource;
		document.head.appendChild(element);
	};

	const removeResource = (id: string): void => {
		const element = document.querySelector(`#${id}`);
		if (element) {
			element.parentNode!.removeChild(element);
		}
	};

	const addStyles = (): void => addResource(ResourceType.STYLE, STYLE_ID, css);

	const removeStyles = (): void => removeResource(STYLE_ID);

	const addScripts = (): void => addResource(ResourceType.SCRIPT, SCRIPTS_ID, scripts as string);

	const removeScripts = (): void => removeResource(SCRIPTS_ID);

	const runScripts = (): void => {
		const innerDiv = element.current!.querySelector('div');
		if (scripts && innerDiv && innerDiv.onload) {
			innerDiv.onload(new Event('load'));
		}
	};

	const handleLoad = (): void => {
		runScripts();
	};

	const addDOMLoadedObserver = (observer: MutationObserver): void => {
		observer.observe(element.current as HTMLDivElement, {
			childList: true,
			attributes: true,
			characterData: true,
		});
	};

	const removeDOMLoadedObserver = (observer: MutationObserver) => {
		observer.disconnect();
	};

	React.useEffect(() => {
		const observer = new MutationObserver(handleLoad);
		addStyles();

		if (scripts) {
			addScripts();
			runScripts();
		}

		addDOMLoadedObserver(observer);

		return () => {
			removeStyles();
			removeScripts();
			removeDOMLoadedObserver(observer);
		};
	}, []);

	return (
		<div
			ref={element}
			dangerouslySetInnerHTML={{ __html: html }}
		/>
	);
};

export default Content;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Page/Content/index.tsx